/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Free Gift Product
  $(document).ready(function(){

      if ($('.option_selected-js').hasClass('add_gift-js')) {
        $('.gift-input--js').prop("disabled", false);
      }
      else {
        $('.gift-input--js').prop("disabled", true);
      }


document.addEventListener('variant:changed', function(event) {
    var variantTitle = event.detail.variant.title;

    if ((variantTitle.includes("2") || variantTitle.includes("3")) && $('.block-swatch.main-block-js').hasClass('add_gift-js')) {
        $('.gift-input--js').prop("disabled", false);
    } else {
        $('.gift-input--js').prop("disabled", true);
    }
});
    
    

  function isCart() {
  if (document.URL.includes("/cart")) return true;
  else false;
}



    $(document).on("click", ".link.main-product--true", function(event) {
  event.preventDefault();
  const $this = $(this);
  const updates = {};
  updates[$this.data("line-id")] = 0;
  
  const productQuantity = parseInt($this.closest(".line-item__info").find(".quantity-selector__input").val(), 10) || 0;

  if (isCart()) {
    $this.parents(".line-item__info").find(".product-item-meta__property input.freegiftId").each(function() {
      const freeGiftId = $(this).val();
      console.log(freeGiftId);
      const currentFreeProductQuantity = parseInt($(`.line-item[data-line-id="${freeGiftId}"]`).find('.quantity-selector__input').val()) || 0;
      const newQuantity = currentFreeProductQuantity - productQuantity; 
      updates[freeGiftId] = newQuantity >= 0 ? newQuantity : 0; // Prevent negative quantities
    });
  } else {
    $this.closest(".line-item__info").find(".product-item-meta__property input.freegiftId").each(function() {
      const freeGiftId = $(this).val();
      const currentFreeProductQuantity = parseInt($(`.line-item[data-line-id="${freeGiftId}"]`).find('.quantity-selector__input').val()) || 0;
      const newQuantity = currentFreeProductQuantity - productQuantity; 
      updates[freeGiftId] = newQuantity >= 0 ? newQuantity : 0; // Prevent negative quantities
    });
  }

  console.log("Updates:", updates);

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
  .then(response => response.json())
  .then(dataResponse => {
    let itemCount = dataResponse.item_count;

    if (isCart()) {
      location.reload();
    } else {
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: dataResponse
          }
        }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
  })
  .catch(error => {
    console.error("Error:", error);
  });
});


// Function to increase quantity
function increaseQuantity(event) {
  var updates = { "updates": {} };
  var $currentLineItem =  $(event).closest('.line-item');
  var $metaProperties = $currentLineItem.find('.line-item__info');
  var $quantityInput = $currentLineItem.find('.quantity-selector__input');
  var quantity = parseInt($quantityInput.val()) + 1;
  $quantityInput.val(quantity);

  updates.updates[$(event).data('line-id')] = quantity;

  if ($metaProperties.find('input.freegiftId').length > 0) { 
    $metaProperties.find('input.freegiftId').each(function(index, data) {
      let freeGiftId = $(this).val();
      const currentFreeProductQuantity = parseInt($(`.line-item[data-line-id="${freeGiftId}"]`).find('.quantity-selector__input').val()) || 0;
      const newQuantity = currentFreeProductQuantity + 1; 
      updates.updates[freeGiftId] = newQuantity >= 0 ? newQuantity : quantity; // Prevent negative quantities
          });
  }

  cartUpdated(updates);
}

// Function to decrease quantity
function decreaseQuantity(event) {
  var updates = { "updates": {} };
  var $currentLineItem =  $(event).closest('.line-item');
  var $metaProperties = $currentLineItem.find('.line-item__info');
  var $quantityInput = $currentLineItem.find('.quantity-selector__input');
  var quantity = parseInt($quantityInput.val()) - 1;
  if (quantity < 0) {
    quantity = 0;
  }
  $quantityInput.val(quantity);

  updates.updates[$(event).data('line-id')] = quantity;

  if ($metaProperties.find('input.freegiftId').length > 0) { 
    $metaProperties.find('input.freegiftId').each(function(index, data) {
      let freeGiftId = $(this).val();
      const currentFreeProductQuantity = parseInt($(`.line-item[data-line-id="${freeGiftId}"]`).find('.quantity-selector__input').val()) || 0;
      const newQuantity = currentFreeProductQuantity - 1; 
      updates.updates[freeGiftId] = newQuantity >= 0 ? newQuantity : quantity; // Prevent negative quantities
    });
  }

  cartUpdated(updates);
}


// Function to update cart
async function cartUpdated(updates) {
  const maxRetries = 2;
  let attempt = 0;

  while (attempt < maxRetries) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: $.param(updates)
      });

      if (response.ok) {
        const dataResponse = await response.json();

        if (isCart()) {
          location.reload();
        } else {
          console.log('Response OK - refreshed');
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: dataResponse
          }
        }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }

        return;
      } else {
        if (response.status >= 500 && response.status < 600 && attempt < maxRetries - 1) {
          console.warn(`Server error, retrying... Attempt ${attempt + 1}/${maxRetries}`);
          attempt++;
          await new Promise(resolve => setTimeout(resolve, 1000));
        } else {
          console.error('Error updating cart, status:', response.status);
          throw new Error('Error updating cart');
        }
      }
    } catch (error) {
      console.error('Request failed:', error);


      if (attempt >= maxRetries - 1) {
        throw new Error('Error updating cart after multiple attempts');
      }

      attempt++;
      await new Promise(resolve => setTimeout(resolve, 1000)); // Retry delay
    }
  }
}


    


// Event listeners
$(document).on('click', '.quantity-selector__button.minus', function(event) {
  event.preventDefault();
  decreaseQuantity($(this));
});

$(document).on('click', '.quantity-selector__button.plus', function(event) {
  event.preventDefault();
  increaseQuantity($(this));
});

    document.addEventListener('cart:updated', function(event) {
  const cart = event.detail.cart;
  console.log(cart);

  let updates = { "updates": {} };

  if (cart.items.length === 1) {
    const freeItem = cart.items.find(item => item.price === 0);

    if (freeItem) {
      updates.updates[freeItem.id] = 0;
    }
  }

  if (cart.items.length === 2) {
    const freeItem = cart.items.find(item => item.price === 0);
    const otherItem = cart.items.find(item => item.price > 0);

    if (freeItem && otherItem) {
      if (otherItem.properties && otherItem.properties['_free gift 1']) {
      if (freeItem.quantity !== otherItem.quantity) {
        updates.updates[freeItem.id] = otherItem.quantity;
      }
      } else {
        updates.updates[freeItem.id] = 0;
      }
    }
  }
  if (Object.keys(updates.updates).length > 0) {
    console.log('Updates to apply:', updates);
    cartUpdated(updates);
  }
});

    function checkAndAddFreeProducts() {
  fetch(window.Shopify.routes.root + "cart.js")
  .then(response => response.json())
  .then(cart => {
  const freeProductsToAdd = new Set();

  cart.items.forEach(item => {
    if (item.properties && item.properties['_free gift 1']) {
      const freeGiftId = item.properties['_free gift 1'];
      freeProductsToAdd.add(freeGiftId);
    } 
  });

  cart.items.forEach(item => {
    if (freeProductsToAdd.has(item.variant_id)) {
      freeProductsToAdd.delete(item.variant_id); 
    }
  });

  const updates = {};
  freeProductsToAdd.forEach(freeProductId => {
    console.log(freeProductId+ ' freeProductId')
    const primaryProduct = cart.items.find(item => item.properties && item.properties['_free gift 1'] === freeProductId);
    if (primaryProduct) {
      updates[freeProductId] = primaryProduct.quantity; 
    }
  });

    console.log('Updates:', updates);
    
  if (Object.keys(updates).length > 0) {
    console.log('workingg')
    cartUpdated(updates);
  } else console.log('not working')
    })
    .catch(error => {
      console.error("Error fetching cart:", error);
    });
    
}
    

  });


  $(document).ready(function(){
    const productVariantElement = document.querySelector('product-variants');
    let PreselectedVariantId = $('product-variants').attr('preselected_id');
    PreselectedVariantId = parseInt(PreselectedVariantId);
    console.log(PreselectedVariantId);
    if (PreselectedVariantId) {
      productVariantElement.selectVariant(PreselectedVariantId);
    }
  });





$(document).ready(function () {
  // Progress Bar
  // function isInViewport(theDiv) {
  // let elementTop = theDiv.offset().top;
  // let elementBottom = elementTop + theDiv.outerHeight();
  // let viewportTop = $(window).scrollTop();
  // let viewportBottom = viewportTop + window.innerHeight;
  // return elementBottom > viewportTop && elementTop < viewportBottom;
  // }
  // var animationDone = false;
  // if ($('#product-block-tested').length) {
  // $(window).on('scroll', function(){
  //   if (!animationDone) {
  //   if(isInViewport($('#product-block-tested'))) {
  //     animationDone = true;
  //     $(".circleBarProgress").each(function () {
  //       var t = $(this).find(".circleBar"),
  //           x = $(this).find(".circleBarWrapper"),
  //           i = $(this).find("span"),
  //           e = parseInt(i.text(), 10);
  //       $({ p: 0 }).animate(
  //           { p: e },
  //           {
  //               duration: 3e3,
  //               easing: "swing",
  //               step: function (e) {
  //                   x.css({background: "conic-gradient(#373737 0deg " + e + "%, #DEDEDC " + e + "%)"}), i.text(0 | e);

  //               },
  //           }
  //       );
  //     });
  //   }
  // }
  // });
  // }

 

   function isInViewport(theDiv) {
      let elementTop = theDiv.offset().top;
      let elementBottom = elementTop + theDiv.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + window.innerHeight;
      return elementBottom > viewportTop && elementTop < viewportBottom;
      }
      var animationDone = false;
      if ($('.pro_vid_img_sec').length) {
      $(window).on('scroll', function(){
        if (!animationDone) {
        if(isInViewport($('.pro_vid_img_sec'))) {
          animationDone = true;
          $(".circleBarProgress").each(function () {
            var t = $(this).find(".circleBar"),
                x = $(this).find(".circleBarWrapper"),
                i = $(this).find("span"),
                e = parseInt(i.text(), 10);
            $({ p: 0 }).animate(
                { p: e },
                {
                    duration: 3e3,
                    easing: "swing",
                    step: function (e) {
                        x.css({background: "conic-gradient(#FFFFFF  0deg,  #a54c4d " + e + "%, #fff  " + e + "%)"}), i.text(0 | e);
                         
                    },
                }
            );
          });
        }
      }
      });
      }
  
  
  // Video slider
  
  $('.instafeef_video_list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    infinite: true, // Enable infinite looping
    dots:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

 // Function to handle the play/pause functionality
  function toggleVideo(videoElement, parentItem) {
    if (videoElement.paused) {
      videoElement.play().catch(function(error) {
        console.error('Error attempting to play the video:', error);
        alert('Sorry, there was an error playing the video.');
      });
      parentItem.addClass('active');
    } else {
      videoElement.pause();
      parentItem.removeClass('active');
    }
  }

  // Function to pause all other videos
  function pauseAllOtherVideos(currentVideo) {
    const videos = $('.instafeef_video_list video');
    videos.each(function() {
      const videoParent = $(this).parents('.video_items');
      if (this !== currentVideo) {
        if (!this.paused) {
          this.pause();
        }
        videoParent.removeClass('active');
      }
    });
  }

  // Click event for the video element
  $('.instafeef_video_list video').click(function() {
    const currentVideo = this;
    const parentItem = $(this).parents('.video_items');
    
    // Pause all other videos and remove 'active' class from their parent elements
    pauseAllOtherVideos(currentVideo);
    
    // Toggle playback of the current video
    toggleVideo(currentVideo, parentItem);
  });

  
    $('.instafeef_video_list .instafeed_hover').click(function() {
    const parentItem = $(this).parents('.video_items');
    const currentVideo = parentItem.find('video')[0];
    if (currentVideo) {
      // Pause all other videos
      pauseAllOtherVideos(currentVideo);
      
      // Toggle playback of the current video
      toggleVideo(currentVideo, parentItem);
    }
  });


// Custom accordion
  if (window.matchMedia("(min-width: 1200px)").matches) {
$('.left_banner_acc').hover(
    function() {

          // Left banner changes
          $(this).attr('class', 'left_banner_acc max-w-[65%] pt-[18px] pb-6 px-[22px] overflow-hidden bg-bgPrimary lg:rounded-[30px] rounded-[20px] relative lg:pt-9 lg:px-6 lg:pb-8 lg:mb-0 mb-2 transition-[max-width,max-height] duration-[400ms] flex-1');
          $(this).find('.left_banner_details_inner').attr('class','left_banner_details_inner max-w-[50%] transition-[width] duration-[400ms]');
          $(this).find('.left_banner_icon_list').attr('class','left_banner_icon_list opacity-1 lg:mb-0 mb-40 flex flex-row gap-6 transition-[opacity] duration-[600ms]');
          $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
          

          // Right banner changes

          $(this).siblings('.right_banners').attr('class', 'right_banners max-w-[35%] flex flex-col gap-2 lg:grid lg:grid-cols-4 lg:grid-rows-4 lg:gap-4 transition-[max-width] duration-[400ms] flex-1')
          $(this).siblings('.right_banners').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-0');
          $(this).siblings('.right_banners').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-0');


          // Right banner 3 changes
          $(this).siblings('.right_banners').find('.right_banner_2_heading').css('width', '100%');

 },
  
    function() {
        // Left banner Class Changes
          $(this).attr('class', 'left_banner_acc max-w-[40%] pt-[18px] pb-6 px-[22px] overflow-hidden lg:rounded-[30px] rounded-[20px] relative lg:pt-9 lg:px-6 lg:pb-8 lg:mb-0 mb-2 transition-[max-width,max-height] duration-[400ms] flex-1');
          $(this).find('.left_banner_details_inner').attr('class','left_banner_details_inner max-w-[200px] transition-[width] duration-[400ms]');
          $(this).find('.left_banner_icon_list').attr('class','left_banner_icon_list opacity-0 lg:mb-0 mb-40 flex flex-row gap-6 transition-[opacity] duration-[600ms]');
          $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');

          //Right banner changes
          $(this).siblings('.right_banners').attr('class', 'right_banners max-w-[60%] flex flex-col gap-2 lg:grid lg:grid-cols-4 lg:grid-rows-4 lg:gap-4 transition-[max-width] duration-[400ms] flex-1');
          $(this).siblings('.right_banners').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-100');
          $(this).siblings('.right_banners').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-100');

        // Right banner 3 changes
          $(this).siblings('.right_banners').find('.right_banner_2_heading').css('width', '50%');
      
      

}
    
    
);


  $('.right_banner_1').hover(
    function() {
      
      // Right banner-1 changes
      $(this).attr('class','right_banner_1 h-[calc(73.5px*4+16px*3)] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_1_other').attr('class','right_banner_1_other opacity-100');
      $(this).find('.right_banner_1_expand_text').attr('class','right_banner_1_expand_text opacity-0 hidden');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      
      // Right banner 2 changes
      $(this).siblings('.right_banner_2').find('.right_banner_header').attr('class','right_banner_header flex-row flex lg:items-start items-center lg:mb-0 mb-4');


      // Right banner 3 changes
     $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-[calc(50%+8px)] max-w-[calc(50%-8px)] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
  },
  
    function() {
       // Right banner-1 changes
      $(this).attr('class','right_banner_1 h-[100%] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_1_other').attr('class','right_banner_1_other opacity-0');
      $(this).find('.right_banner_1_expand_text').attr('class','right_banner_1_expand_text opacity-100');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      

      // Right banner 2 changes
       $(this).siblings('.right_banner_2').find('.right_banner_header').attr('class','right_banner_header flex lg:items-start items-center lg:mb-0 mb-4');
      
      // Right banner 3 changes
      $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-0 max-w-[100%] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
 
  }
        
);


    $('.right_banner_2').hover(
    function() {
      
      // Right banner-2 changes
      $(this).attr('class','right_banner_2 h-[calc(73.5px*4+16px*3)] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_2_other').attr('class','right_banner_2_other opacity-100');
      $(this).find('.right_banner_2_expand_text').attr('class','right_banner_2_expand_text opacity-0 hidden');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      

      // Right banner 3 changes
     $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-0  max-w-[calc(50%-8px)] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
  },
  
    function() {
       // Right banner-1 changes
      $(this).attr('class','right_banner_2 h-[100%] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1')
      $(this).find('.right_banner_2_other').attr('class','right_banner_2_other opacity-0');
      $(this).find('.right_banner_2_expand_text').attr('class','right_banner_2_expand_text opacity-100');
      $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');
      
      // Right banner 3 changes
      $(this).siblings('.right_banner_3_wrapp').find('.right_banner_3').attr('class','right_banner_3 left-0 max-w-[100%] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
 
  }
        
);

    $('.right_banner_3').hover(
    function() {
      
      // Right banner 3 changes
        $(this).attr('class','right_banner_3 max-h-[calc(100%+36.75px)] !h-[calc(100%+36.75px)] lg:rounded-[24px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
        $(this).find('.banner_icon').attr('class','banner_icon opacity-0 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');

      // Right banner 1 changes
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').attr('class','right_banner_1 h-[calc(73.5px*1.5+16px)] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_heading').css('width','100%');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-0');

      // Right banner 2 changes
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').attr('class','right_banner_2 h-[calc(73.5px*1.5+16px)] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_heading').css('width','70%');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-0');

    },
  
    function() {
      // Right banner 3 changes
        $(this).attr('class','right_banner_3 left-0 max-w-[100%] max-h-[calc(50%-8px)] lg:rounded-[50px] rounded-[20px] pt-3 px-[22px] bg-[linear-gradient(270deg,_#F18979_-6.71%,_#F3E4BF_-6.69%,_#EF776A_113.34%)] lg:py-5 lg:px-6 lg:h-full w-full lg:absolute bottom-0 overflow-hidden transition-all duration-[400ms]');
        $(this).find('.banner_icon').attr('class','banner_icon opacity-100 transition-[opacity] duration-150 absolute lg:w-[45px] lg:h-[45px] lg:right-4 lg:bottom-4 lg:top-auto w-9 h-9 top-4 right-[10px]');

      // Right banner 1 changes
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').attr('class','right_banner_1 h-[100%] lg:block hidden bg-[#EF776A] relative row-start-1 row-end-4 col-start-1 col-end-3 rounded-[30px] pt-9 px-6 pb-8 z-[1] overflow-hidden transition-[max-width,height] duration-[400ms] flex-1');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_heading').css('width','100%');
       $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_1').find('.right_banner_1_expand_text').attr('class', 'right_banner_1_expand_text opacity-100');
  
      // Right banner 2 changes
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').attr('class','right_banner_2 h-[100%] rounded-[20px] pt-[10px] px-[22px] bg-[#EBDFCF] relative lg:row-start-1 lg:row-end-4 lg:col-start-3 lg:col-end-5 lg:rounded-[30px] lg:pt-9 lg:px-6 lg:pb-8 z-[1] overflow-hidden transition-[max-width,max-height,height] duration-[400ms] flex-1');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_heading').css('width','50%');
      $(this).parents('.right_banner_3_wrapp').siblings('.right_banner_2').find('.right_banner_2_expand_text').attr('class', 'right_banner_2_expand_text opacity-100');

      
  }
        
);
  }
  else{
    $('.banner-accordion-item').click(function() {
      $(this).toggleClass('active');
      $(this).find('.banner_accordion-content').slideToggle();
    });
  }
  

    // Custom testimonial 2
$(document).ready(function(){
  $('.custom-testimonial-slider-inner').slick({
    slidesToShow:3,
    slidesToScroll: 1,
    infinite: false,
    dots:true,
    arrows:false,
    responsive: [
       {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
  
   // Featured with collection
  var $slider1 = $(".featured-collection-slider");

  $slider1.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    speed: 400,
    infinite: true, // Enable infinite looping
    swipeToSlide: true,
    dots:true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  var $slider = $(".result_slider");
  var $multicolumnProgressBar = $(".multicolumn_progress__bar");
  var $progressBarLabel = $(".slider__label");

  // Set initial background size and aria-valuenow
  $multicolumnProgressBar
    .css("background-size", "2% 100%")
    .attr("aria-valuenow", 2);

  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = (nextSlide / (slick.slideCount - 1)) * 100;

    if (calc === 0) {
      $multicolumnProgressBar
        .css("background-size", "2% 100%")
        .attr("aria-valuenow", 2); // Set background size to 2% if next slide is the first one
    } else {
      $multicolumnProgressBar
        .css("background-size", calc + "% 100%")
        .attr("aria-valuenow", calc);
    }

    $progressBarLabel.text(calc + "% completed");
  });

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    speed: 400,

    infinite: true, // Enable infinite looping
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 741,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });

  // Footer item Toggle
  // if (window.matchMedia("(max-width: 999px)").matches) {
  //   $(".footer__item--links .footer__item-title").click(function () {
  //     $(this).siblings(".footer__item-content").slideToggle();
  //     $(this).parents(".footer__item").toggleClass("active");
  //   });
  // }

  // Product FAQ
  // $(".faq-question").click(function () {
  //   $(this)
  //     .siblings()
  //     .slideToggle()
  //     .parents(".product-faq-item")
  //     .toggleClass("active");
  //   $(this)
  //     .parents(".product-faq-item")
  //     .siblings()
  //     .removeClass("active")
  //     .find(".faq-answer")
  //     .slideUp();
  // });

   //DEFAULT COLLAPSE JAVASCRIPT START
  $(document).on("click","[data-toggle='collapse']",function() {
    var parent = $(this).data("parent");
    var target = $(this).data("href");
    if($(parent).length && $(parent).hasClass('panel-group')) {
     $(parent+" .panel").each(function() {
       var p = $(this).find("[data-toggle='collapse']");
       var t = p.data("href");
       if(t!= target && p.attr("aria-expanded") == "true") {
        $(t).slideUp().removeClass("in");
        p.addClass("quia-collapsed").attr("aria-expanded","false");
       }
     });
    }
    if($(this).attr("aria-expanded") == "false") {
      $(target).slideDown().addClass("in");
      $(this).removeClass("quia-collapsed").attr("aria-expanded","true");
    } else {
      $(target).slideUp().removeClass("in");
      $(this).addClass("quia-collapsed").attr("aria-expanded","false");
    }
  });
  //DEFAULT COLLAPSE JAVASCRIPT END
});

// Cart Drawer countdown timer js start

// function setCookie(name, value, days) {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// function getCookie(name) {
//     const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }

// if (getCookie('timer') > new Date().getTime()) {
//     var time = getCookie('timer');
//     var timer = setInterval(function() {
//         var left = time - new Date().getTime();
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//                 var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// } else {
//     // Set timer for 1 hour, 59 minutes, and 58 seconds
//     var time = new Date().getTime() + (1 * 60 * 60 * 1000) + (59 * 60 * 1000) + (58 * 1000);
//     document.cookie = 'timer=' + time + '; path=/; domain=quiabeauty.com; secure=true; expires=' + new Date(new Date().getTime() + 3600000 * 24).toUTCString();

//     var timer = setInterval(function() {
//         var left = time - new Date().getTime();
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//                 var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// }

// function setCookie(name, value, days) {
//     var expires = "";
//     if (days) {
//         var date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/";
// }

// function getCookie(name) {
//     const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }

// function getUserTimeZoneOffset() {
//     // Get the user's time zone offset in minutes
//     return new Date().getTimezoneOffset();
// }

// if (getCookie('timer') > new Date().getTime()) {
//     var time = getCookie('timer');
//     var timer = setInterval(function() {
//         var left = time - new Date().getTime();
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//         var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// } else {
//     // Get the current time in the user's local time zone
//     var currentTime = new Date();

//     // Calculate the time until midnight
//     var midnight = new Date(currentTime);
//     midnight.setHours(24, 0, 0, 0); // Set to 12:00 AM of the next day

//     // Calculate the time remaining until midnight (in milliseconds)
//     var timeRemaining = midnight.getTime() - currentTime.getTime();

//     // Save the adjusted timer value in the cookie
//     document.cookie = 'timer=' + (currentTime.getTime() + timeRemaining) + '; path=/; domain=quiabeauty.com; secure=true; expires=' + new Date(currentTime.getTime() + timeRemaining + 3600000 * 24).toUTCString();

//     var timer = setInterval(function() {
//         var left = timeRemaining - (new Date().getTime() - currentTime.getTime());
//         var hours = Math.floor(left / (1000 * 60 * 60));
//         var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
//         var seconds = Math.floor((left % (1000 * 60)) / 1000);

//         hours = ('0' + hours).slice(-2);
//         minutes = ('0' + minutes).slice(-2);
//         seconds = ('0' + seconds).slice(-2);

//         var hoursElement = document.querySelector('#js-clock-hours');
//         var minutesElement = document.querySelector('#js-clock-minutes');
//         var secondsElement = document.querySelector('#js-clock-seconds');
        
//         if (hoursElement && minutesElement && secondsElement) {
//             hoursElement.innerHTML = hours;
//             minutesElement.innerHTML = minutes;
//             secondsElement.innerHTML = seconds;
//         }

//         if (left <= 1000) {
//             clearInterval(timer);
//             document.cookie = 'timer=""; path=/; domain=quiabeauty.com; secure=true; expires=-1';
//             location.reload();
//         }
//     }, 1000); // Changed interval to 1000ms for 1-second updates
// }




// Cart Drawer countdown timer js end


const block = document.querySelectorAll(".block");

const options = {
  threshold: 0.5, // Trigger when 50% of the element is visible
};

const observer = new IntersectionObserver(function (entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      let item = entry.target;
      let numElement = item.querySelector(".num");
      let num = parseInt(numElement.innerText);
      let count = 0;
      let time = 2000 / num;
      let circle = item.querySelector(".desktop-svg");
      let mobCircle = item.querySelector(".mobile-svg");
      setInterval(() => {
        if (count == num) {
          clearInterval();
        } else {
          count += 1;
          numElement.innerText = count;
        }
      }, time);
      circle.style.strokeDashoffset = 503 - 503 * (num / 100);
      mobCircle.style.strokeDashoffset = 270 - 270 * (num / 100);
      let dots = item.querySelector(".dots");
      dots.style.transform = `rotate(${360 * (num / 100)}deg)`;
      if (num == 100) {
        dots.style.opacity = 0;
      }
      observer.unobserve(item); // Stop observing once animation starts
    }
  });
}, options);

block.forEach((item) => {
  observer.observe(item);
});

$(document).ready(function () {
  $(document).on("click", ".product-custom-varaint .block-swatch", function () {
    var variantChange = $(this).find(".block-swatch__radio").data("id");
    $(this).find(".block-swatch__radio").addClass("active");
    $(this).siblings().find(".block-swatch__radio").removeClass("active");
    var variantPrice = $(this).find(".block-swatch__radio").data("price");
    $(this)
      .parents(".product-pair")
      .find(".pair-product-add_to_cart_text span")
      .text(variantPrice);
    var variantDataId = $(this)
      .parents(".product-pair")
      .find(".ajax-add-to-cart")
      .attr("data-variantId", variantChange);
  });

$(document).on("click", ".ajax-add-to-cart", function () {
  var ajaxVariantID = $(this).attr("data-variantId");
  addToCartJS(1, ajaxVariantID, $(this));
});

function addToCartJS(qty, variantID, btn) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      btn.find('.pair-product-add_to_cart_text').html("added");
    }
  };
  var data = JSON.stringify({ quantity: qty, id: variantID });
  xhr.send(data);
}


  //   $('.gallery-carousel').slick({
  //   slidesToShow: 4,
  //   dots:false,
  //   centerMode: false,
  //   infinite:true,
  //   appendArrows: $('.product-gallery_arrow'),
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 741,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         adaptiveHeight: true,
  //       },
  //     },
  //   ],
  // });

  $(".custom-testimonial-left-slider").slick({
    slidesToShow: 1,
    dots: false,
    centerMode: false,
    infinite: true,
    asNavFor: $(".custom-testimonial-right-slider"),
    arrows: false,
  });

  $(".custom-testimonial-right-slider").slick({
    slidesToShow: 1,
    dots: true,
    centerMode: false,
    infinite: true,
    asNavFor: $(".custom-testimonial-left-slider"),
    appendArrows: $(".testimonial-slider-arrow"),
    appendDots: $(".custom-pagination"),
  });

  $(".video-slider-wrapper").slick({
    slidesToShow: 4,
    dots: false,
    centerMode: true,
    centerPadding: "7%", // Adjust this value as needed for 20-30% visibility
    infinite: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1351,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          centerPadding: "7%", // Adjust this value as needed for 20-30% visibility
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "12%", // Adjust this value as needed for 20-30% visibility
        },
      },
      {
        breakpoint: 543,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "10%", // No need for centerPadding if centerMode is false
        },
      },
    ],
  });

 
});

// $(document).ready(function () {
//   $("#shopify-section-sections--17810013585628__image_with_content_pPaxJi").css(
//     "opacity",
//     "0"
//   );
//   var footerTop = $("footer").offset().top - 350;
//   $(window).scroll(function () {
//     if ($(window).scrollTop() > footerTop) {
//       $(
//         "#shopify-section-sections--17810013585628__image_with_content_pPaxJi"
//       ).css("opacity", "1");
//     } else {
//       $(
//         "#shopify-section-sections--17810013585628__image_with_content_pPaxJi"
//       ).css("opacity", "0");
//     }
//   });
// });

$(document).on(
  "click",
  ".purchase-details__buttons .product-form__add-button",
  function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.attr("disabled", true);
    $this.append("<div class='custom_loader'></div>");
    $this.find("span").hide();
    $this.find(".add-icon").hide();
    let upsellId = $this.closest("form").find("input[name=id]").val();
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          if (!document.getElementById("mini-cart").open == true) {
            document.getElementById("mini-cart").open = true;
          }
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
          }, 500);
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          if (response) {
            response = response.description;
            $(".warning").remove();
            var warning =
              '<p class="warning animated bounceIn">' +
              response.replace("All 1 ", "All ") +
              "</p>";
            $this.after(warning);
          }
        },
      });
    }
  }
);

$(document).on(
  "click",
  ".product-item__cta-wrapper .product-item__cta",
  function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.attr("disabled", true);
    $this.append("<div class='custom_loader'></div>");
    $this.find("span").hide();
    $this.find(".add-icon").hide();
    let upsellId = $this.closest("form").find("input[name=id]").val();
    if (upsellId) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: upsellId,
        },
        dataType: "json",
        success: function (data) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          if (!document.getElementById("mini-cart").open == true) {
            document.getElementById("mini-cart").open = true;
          }
          setTimeout(function () {
            $this.find("span").show();
            $(".custom_loader").remove();
            $this.attr("disabled", false);
          }, 500);
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          if (response) {
            response = response.description;
            $(".warning").remove();
            var warning =
              '<p class="warning animated bounceIn">' +
              response.replace("All 1 ", "All ") +
              "</p>";
            $this.after(warning);
          }
        },
      });
    }
  }
);

$(document).ready(function () {
  
  // var interval;
  // interval = setInterval(function () {
  //    if ($(".mini-cart__recommendations-list.slick-initialized").length <= 0) {

  //       var $slider = $('.mini-cart__recommendations-list');
  //   var $progressBar = $('.progress__bar, .progress__bar_item');
  //   var $progressBarLabel = $('.slider__label');

  //   // Set initial background size and aria-valuenow
  //   $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2);

  //   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  //     var calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

  //     if (calc === 0) {
  //       $progressBar.css('background-size', '2% 100%').attr('aria-valuenow', 2); // Set background size to 2% if next slide is the first one
  //     } else {
  //       $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
  //     }

  //     $progressBarLabel.text(calc + '% completed');
  //   });

       
  //       $slider.slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false
  //     });
  //   }
  // }, 500);


$(document).on('change', '.rc-radio__input', function() {
    var subscribePrice;
    if ($('.rc-radio__input[value="subscription"]:checked').length > 0) {
        subscribePrice = $(this).siblings('.rc-radio__label').find('.rc-radio__price').text();
        $('.product-form__add-button').find('.price').text(subscribePrice);
    } else {
        oneTimeText = $(this).siblings('.rc-radio__label').text();
        oneTimePrice = oneTimeText.replace('One-time purchase', '').trim(); 
        $('.product-form__add-button').find('.price').text(oneTimePrice);
    }
});

 if ($('.template--product').length > 0) {
  var intervalId = setInterval(function () {
    if (document.location.href.includes("selling_plan")) {
    console.log("Interval start");

    if ($('.rc-template__radio').length > 0) {
       var subscribePrice = $('.rc-radio__input[value="subscription"] + .rc-radio__label .rc-radio__price').text();
        console.log(subscribePrice);
        $('.product-form__add-button').find('.price').text(subscribePrice);       
          clearInterval(intervalId);   
      console.log("Interval cleared");
    }

        setTimeout(function() {
          clearInterval(intervalId);
          console.log("Time Out");
        }, 5000);
      
      }
  }, 100);

 }







// $('.block-swatch__radio__cusotm').change(function(){
//   var dataPrice = $(this).siblings('.block-swatch__item__custom').find('.large-title').text(); 
//     $(this).parents('.product__info').find('.product-custom-price').text(dataPrice);

// });



 // $('.product-icon-volume').click(function(){
 //      var activeVideo = $('.video-active video')[0];
 //      if (activeVideo) {
 //        activeVideo.muted = !activeVideo.muted;
 //        $(this).toggleClass("volume-muted", activeVideo.muted);
 //      }
 //  });
});


 // function playPause(videoId, buttonId) {
 //    var myVideo = document.getElementById(videoId);
 //    var $button = $("#" + buttonId);

 //    // Pause all other videos
 //    $('video').not(myVideo).each(function() {
 //      this.pause();
 //      var otherButtonId = $(this).siblings(".video-control").attr('id');
 //      $("#" + otherButtonId).removeClass("btnhide");
 //      $("#" + otherButtonId).parents('.popup-video').removeClass('video-active');
 //      $("#" + otherButtonId).parents('body').removeClass('video-popup-active');
 //    });

 //    if (myVideo.paused) {
 //      myVideo.play();
 //    } else {
 //      myVideo.pause();
 //    }

 //    // Toggle class on the current button
 //    $button.toggleClass("btnhide");
 //    $button.parents('.popup-video').addClass('video-active');
 //    $button.parents('body').addClass('video-popup-active');
 //  }

 //  function videoClose() {

 //      var activeVideo = $('.video-active video')[0]; // Get the active video element
 //      if (activeVideo) {
 //        activeVideo.pause(); // Pause the active video
 //        var activeButtonId = $(activeVideo).siblings(".video-control").attr('id');
 //        $("#" + activeButtonId).removeClass("btnhide"); // Remove "btnhide" class from the button associated with the active video
 //      }
 //      $('body').removeClass('video-popup-active');
 //      $('.popup-video').removeClass('video-active');

 //  }


// Flicity slider counter
    var slides = document.querySelectorAll('.product__media-item');
    var sliderWrapper = document.querySelector('.product__media-list');
    var currentSlide = 0;
    var totalSlides = slides.length;
    var startX, currentX, xOffset = 0;
    var isDragging = false;

function showSlide(index) {
      if (index >= 0 && index < totalSlides) {
        currentSlide = index;
        // sliderWrapper.style.transform = 'translateX(-' + (100 * currentSlide) + '%)';
        updateSlideCount();
      }
    }

$('.template-wrapping-mask-b .product__media-prev-next').click(function() {
  
  
  setTimeout(function() {
  updateSlideCount();
  }, 200);

});



  function updateSlideCount(){
     var curSlide = $('.template-wrapping-mask-b .product__media-prev-next').siblings('.dots-nav').find('.dots-nav__item[aria-current="true"]').data('counter');
      var totalSlide = $('.dots-nav').data('slideitem');
      $('.template-wrapping-mask-b .product__media-prev-next').siblings('.slider-container').find('#slider-counter').text(`${curSlide}/${totalSlide}`)
  }
  function handleDragStart(event) {
      isDragging = true;
      startX = event.clientX || event.touches[0].clientX;
    }
    function handleDragMove(event) {
      if (!isDragging) return;
      currentX = event.clientX || event.touches[0].clientX;
      xOffset = startX - currentX;
      // sliderWrapper.style.transform = 'translateX(-' + (100 * currentSlide + xOffset / window.innerWidth * 100) + '%)';
    }
    function handleDragEnd(event) {
      setTimeout(function() {
  updateSlideCount();
  }, 200);
      // isDragging = false;
//       var threshold = window.innerWidth / 4;
//       if (xOffset < -threshold && currentSlide < totalSlides - 1) {
//         showSlide(currentSlide + 1);
//       } else if (xOffset > threshold && currentSlide > 0) {
//         showSlide(currentSlide - 1);
//       } else {
// console.log(currentSlide);
//         showSlide(currentSlide);
//       }
    }
if (sliderWrapper != null) {
    sliderWrapper.addEventListener('mousedown', handleDragStart);
    sliderWrapper.addEventListener('mousemove', handleDragMove);
    sliderWrapper.addEventListener('mouseup', handleDragEnd);
    sliderWrapper.addEventListener('mouseleave', handleDragEnd);
    sliderWrapper.addEventListener('touchstart', handleDragStart);
    sliderWrapper.addEventListener('touchmove', handleDragMove);
    sliderWrapper.addEventListener('touchend', handleDragEnd);
}
    
     setTimeout(function() {
  updateSlideCount();
  }, 200);

// Change flag based on country
   const countryMapping = {
            "US": "United States",
            "CA": "Canada",
            "GB": "United Kingdom",
            "AU": "Australia",
            "DE": "Germany",
            "IT": "Italy",
            "IE": "Ireland",
            "NZ": "New Zealand",
            "CH": "Switzerland",
            "NL": "Netherlands",
            "DK": "Denmark",
            "BE": "Belgium",
            "AE": "United Arab Emirates",
            "SE": "Sweden",
            "IL": "Israel",
            "SG": "Singapore",
            "ES": "Spain",
            "AT": "Austria",
            "MT": "Malta",
            "BD": "Bangladesh",
        };

$.get("https://ipinfo.io", function(response) { 

    var countryCode = response.country.toLowerCase();
   const countryName = countryMapping[ response.country] || response.country;
    var flagIcon = countryName+ `<span class="flag-icon flag-icon-${countryCode}"></span>`;
    $(".country1").html(flagIcon);
}, "jsonp");


$(document).ready(function(){
  $('.popup_title').click(function(){
    $(this).parents('.popup_wrapper').addClass('active');
  });

   $('.popup_close').click(function(){
    $(this).parents('.popup_wrapper').removeClass('active');
     
  });

  
});


// var carouselStatus = document.querySelector('#slider-counter');

//   // var flkty = new Flickity('.product__media-list', {
//   //   cellAlign: 'left',
//   //   contain: true
//   // });

// function updateStatus() {
//   var slideNumber = flkty.selectedIndex + 1;
//   carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
// }
// updateStatus();

// flkty.on( 'select', updateStatus );



   $(document).on("click", ".product-video-block .video-control", function() {

       var clickedControl = $(this).parents('.video-item');
       var clickedVideo = clickedControl.find('video')[0];
       var videoHtml = clickedControl.find('.show').html();
       // Move the video to the main popup
       $('.main-product-popup').html(videoHtml);

       // Pause all other videos
       $('.popup-video video').not(clickedVideo).each(function() {
           this.pause();
           $(this).siblings('.video-control').removeClass('btnhide');
       });

       // Toggle play/pause and update control icon for the video in the main popup
       var mainPopupVideo = $('.main-product-popup video')[0];
       if (mainPopupVideo.paused) {
           mainPopupVideo.play();
           $('.main-product-popup .video-control').addClass('btnhide');
       } else {
           mainPopupVideo.pause();
           $('.main-product-popup .video-control').removeClass('btnhide');
       }

       // Activate the main popup
       $('.main-product-popup').addClass('video-active');
       $('body').addClass('video-popup-active');
   });

     $(document).on("click", ".main-product-popup .icon-close", function() {
       // Pause and close the video in the main popup
       var mainPopupVideo = $('.main-product-popup video')[0];
       if (mainPopupVideo) {
           mainPopupVideo.pause();
           $('.main-product-popup .video-control').removeClass('btnhide');
       }

       $('body').removeClass('video-popup-active');
       $('.main-product-popup').removeClass('video-active');
       $('.main-product-popup').empty();
  });

   $(document).on("click", ".main-product-popup .icon-volume", function() {
   console.log("this = ", this);
   	var mainPopupVideo = $(this).parents('.main-product-popup').find('video')[0];
   	console.log("mainPopupVideo", mainPopupVideo);
   	if (mainPopupVideo) {
   		mainPopupVideo.muted = !mainPopupVideo.muted;
   		$(this).toggleClass("volume-muted", mainPopupVideo.muted);
   	}
   });

// $(document).ready(function() {
//     // Select the video elements
//     var video1 = $('#video-poster-1 video')[0];
//     var video2 = $('#video-poster-2 video')[0];
//     // Function to start playing video 1 and stop video 2
//     function playVideo1() {
//         video2.pause();
//         video2.currentTime = 0; // Optional: Reset video 2 to the start
//         video1.play();
//         setTimeout(function() {
//             playVideo2();
//         }, 4000); // Wait for 4 seconds before switching to video 2
//     }
//     // Function to start playing video 2 and stop video 1
//     function playVideo2() {
//         video1.pause();
//         video1.currentTime = 0; // Optional: Reset video 1 to the start
//         video2.play();
//         setTimeout(function() {
//             playVideo1();
//         }, 4000); // Wait for 4 seconds before switching back to video 1
//     }
//     // Start the loop with video 1
//     playVideo1();
// });
$(document).ready(function() {
    var video1 = $('#video-poster-1 video')[0];
    var video2 = $('#video-poster-2 video')[0];

    if (!video1 || !video2) return;

    function playVideo1() {
        video2.pause();
        video2.currentTime = 0;
        video1.muted = true;
        video1.play();

        setTimeout(function() {
            playVideo2();
        }, 4000);
    }
    function playVideo2() {
        video1.pause();
        video1.currentTime = 0;
        video2.muted = true;
        video2.play();

        setTimeout(function() {
            playVideo1();
        }, 4000);
    }
    playVideo1();
});


$(document).ready(function () {
  var shippingDays = 2;
  function getFormattedDate(date) {
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    let day = days[date.getDay()] + ', ' + date.getDate();
    let month = monthNames[date.getMonth()];

    return `${day} ${month}`;
  }

  function addDaysToDate(date, daysToAdd) {
    let newDate = new Date(date);
    newDate.setDate(date.getDate() + daysToAdd);

    return newDate;
  }

  let todaysDate = new Date();
  let nexttwodaysdate = addDaysToDate(
    todaysDate, shippingDays);
  
  $(".deliverydate").text(" " + getFormattedDate(nexttwodaysdate));




});

// function giftAddToCart(productId) {
//     var data = {
//         items: [{
//             id: productId,
//             quantity: 1 
//         }]
//     };

//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(data)
//     })
//     .then(response => {
//         if (!response.ok) {
//             throw new Error('Network response was not ok ' + response.statusText);
//             location.reload();
//         }
//         return response.json();
//     })
//     .then(data => {
//         console.log('Item added to cart:');
//     })
//     .catch(error => {
//         console.error('There was a problem with the fetch operation:', error);
//     });
// }

//  document.addEventListener('addToCartButtonClicked', (e) => {
//      var inputValue = $('input[name="items[1][id]"]');

//     if (!inputValue.prop('disabled') && inputValue.length > 0) {
//         var productId = inputValue.val(); 
//         console.log('Product ID:', productId);
//         giftAddToCart(productId);
        
//     }
//  })


// $(document).ready(function() {
//     // Step 1: Fetch the current cart
//     fetch(window.Shopify.routes.root + 'cart.js')
//         .then(response => {
//             if (!response.ok) {
//                 throw new Error('Network response was not ok ' + response.statusText);
//             }
//             return response.json();
//         })
//         .then(cart => {
//             // Step 2: Check the conditions for the cart
//             if (cart.item_count === 1) {
//                 const lineItem = cart.items[0];
                
//                 // Condition 1: If the product is free (price is 0)
//                 if (lineItem.price === 0) {
//                   console.log(lineItem);
//                   removeFromCart(lineItem.id); 
//                 } 
//                 // Condition 2: If the product is not free
//                 else {
//                     const freeGiftProperty = lineItem.properties["_free gift 1"];
//                     if (freeGiftProperty) {
//                         addToCart(freeGiftProperty); // Add the free gift product
//                     }
//                 }
//             }
//         })
//         .catch(error => {
//             console.error('There was a problem with the fetch operation:', error);
//         });
// });

// // Function to remove a product from the cart
// function removeFromCart(productId) {
//     let id = productId;
//     if (typeof productId === 'object') {
//         id = `${productId.product_id}:${productId.variant_id}`;
//     }

//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ updates: { [id]: 0 } }) // Set quantity to 0 to remove
//     })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Product removed from cart:', data);
//         refreshCart();
//     })
//     .catch(error => {
//         console.error('Error removing product:', error);
//     });
// }

// // Function to add a product to the cart
// function addToCart(productId) {
//     const data = {
//         items: [{
//             id: productId,
//             quantity: 1 // Set quantity to 1
//         }]
//     };

//     fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(data)
//     })
//     .then(response => response.json())
//     .then(data => {
//         console.log('Product added to cart:', data);
//         refreshCart();
//     })
//     .catch(error => {
//         console.error('Error adding product:', error);
//     });
// }

// // Function to refresh the cart drawer
// function refreshCart() {
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true
//     }));
// }


  // // Triggered when an offer is added
  // document.addEventListener('candyrack-offer-added', (e) => {
    
  // })
  // document.addEventListener('candyrack-offer-removed', (e) => {
    
  // })


  // document.addEventListener('candyrack-closed', (e) => {
  //   var inputValue = $('input[name="items[1][id]"]');

  //   if (!inputValue.prop('disabled')) {
  //       var productId = inputValue.val(); 
  //       console.log('Product ID:', productId);
  //       giftAddToCart(productId);
        
  //   }
  // });


$(document).ready(function() {
  $('.reviews-slider-product-info').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    dots: true,
    responsive: [
      {
        breakpoint: 768, // Example for tablet screens
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480, // Example for mobile screens
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

// SHIPPING INSURANCE JS START

// function refreshCart() {
//     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
// }

// $(document).ready(function () {
//     const shippingProductVariantId = "43256435114031";
//     const localStorageKey = "shipping_protection_disabled";

//     function isShippingProtectionInCart(cart) {
//         return cart.items.some(item => item.variant_id == shippingProductVariantId);
//     }

//     function addShippingProtectionToCart() {
//             $.ajax({
//                 type: "POST",
//                 url: "/cart/add.js",
//                 data: { quantity: 1, id: shippingProductVariantId },
//                 dataType: "json",
//                 success: function () {
//                     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//                 },
//                 error: function (error) {
//                     console.error("Error adding shipping protection:", error);
//                 }
//             });
//     }

//     function removeShippingProtectionFromCart() {
//         $.getJSON("/cart.js", function (cart) {
//             const item = cart.items.find(item => item.variant_id == shippingProductVariantId);
//             if (item) {
//                 $.ajax({
//                     type: "POST",
//                     url: "/cart/change.js",
//                     data: { quantity: 0, id: item.key },
//                     dataType: "json",
//                     success: function () {
//                         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//                     },
//                     error: function (error) {
//                         console.error("Error removing shipping protection:", error);
//                     }
//                 });
//             }
//         });
//     }

//     document.addEventListener('cart:updated', function (event) {
//       var cart = event.detail.cart;
//       console.log("updating");
//       if (!isShippingProtectionInCart(cart) && !localStorage.getItem(localStorageKey)) {
//               addShippingProtectionToCart();
//           }
//       if (cart.item_count === 1 && isShippingProtectionInCart(cart) ) {
//         removeShippingProtectionFromCart();
//       }
//     });

//     $(document).on("click", ".upcart-addons-toggle-js", async function () {
//         const $toggle = $(this).find(".styles_ToggleSwitch__");
//         const $circle = $(this).find(".styles_ToggleSwitch__circle__");
//         const $button = $(this);

//         $button.prop("disabled", true).attr("aria-busy", "true");

//         $toggle.toggleClass("styles_ToggleSwitch--active__");
//         $circle.toggleClass("styles_ToggleSwitch__circle--active__");

//         const isActive = $toggle.hasClass("styles_ToggleSwitch--active__");

//         try {
//             if (isActive) {
//                 await addShippingProtectionToCart();
//             } else {
//                 await removeShippingProtectionFromCart();
//                 localStorage.setItem(localStorageKey, true);
//             }
//         } catch (error) {
//             $toggle.toggleClass("styles_ToggleSwitch--active__");
//             $circle.toggleClass("styles_ToggleSwitch__circle--active__");
//         } finally {
//             $button.prop("disabled", false).attr("aria-busy", "false");
//         }
//     });
// });

// SHIPPING INSURANCE JS END


$('variant-picker input[type="radio"]').on('change', function () {

    let selectedVariant = $(this).data('variantid');

    let $stickyBtn = $('#product-sticky-btn');

    $stickyBtn.find('.sticky_atc_form input[name="id"]').val(selectedVariant);
    $('input.current-variant-id[name="id"]').val(selectedVariant);

    let variantImageSrc = $(this).closest('.block-swatch').find('.variant_image img').attr('src');
    let discountText = $(this).closest('.block-swatch').find('.variant_price_discount').text();
let variantPercentage = discountText.match(/\d+%/);

if (variantPercentage) {
    variantPercentage = variantPercentage[0]; 
} else {
    variantPercentage = ""; 
}


  $('#AddToCart').find('.varaint_price').text(variantPercentage)

    $stickyBtn.find('.button_sticky_wrapper__product-image').attr('src', variantImageSrc);
});


$(document).ready(function () {
  $('.block-swatch__radio[type="radio"]').on('change', function () {
    var selectedVariantId = $(this).attr('data-variantid');

    $('.shopify-product-form input[name="id"]').val(selectedVariantId);
  });
});

